var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, styled } from "@mui/material";
import React from "react";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var SecondaryMainHeading = function (_a) {
    var children = _a.children, backToButton = _a.backToButton, secondaryHeadingTitle = _a.secondaryHeadingTitle, backgroundImage = _a.backgroundImage;
    var Container = styled(Box)({
        height: "135px",
        padding: "32px",
        backgroundImage: backgroundImage ? "url(".concat(backgroundImage, ")") : "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPositionX: "right",
        backgroundPositionY: "bottom",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    });
    var MainFunctionAndLevelTitle = styled(Box)({
        display: "flex",
        flexDirection: "row",
    });
    var FunctionAndLevelTitle = styled(Box)({
        fontFamily: "var(--font-stack-full-medium)",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "32px",
        lineHeight: "54px",
        color: "var(--grey-color-90)",
        letterSpacing: "-0.41",
    });
    return (_jsxs(Container, __assign({ "data-testid": "secondHeading" }, getAutomationTag(TestTag.SecondaryHeadingContainer), { children: [backToButton, _jsx(MainFunctionAndLevelTitle, { children: _jsx(FunctionAndLevelTitle, __assign({}, getAutomationTag(TestTag.PrimaryPageHeader), { children: secondaryHeadingTitle })) }), children] })));
};
export default SecondaryMainHeading;
